// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_3h-1";
export var movingGradient = "_3h-4";
export var movingGradientBlock = "_3h-2";
export var skeleton = "_3h-0";
export var skeletonText = "_3h-3";